import { render, staticRenderFns } from "./commonBook.vue?vue&type=template&id=4d4baec6&scoped=true"
import script from "./commonBook.vue?vue&type=script&lang=js"
export * from "./commonBook.vue?vue&type=script&lang=js"
import style0 from "./commonBook.vue?vue&type=style&index=0&id=4d4baec6&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4d4baec6",
  null
  
)

export default component.exports